import React from "react";
import { Link, useLocation } from "react-router-dom";

/**
 * Rendered for any URL that doesn't match a known route. Notably, this
 * REPLACES the previous behavior where `path="*"` fell through to RootRoute
 * → HomePage — so typos and stale bookmarks now show a clear "not found"
 * page instead of silently landing on Home.
 *
 * The legitimate Slack-link path `/?tool=X&cycle=Y` still hits `/` directly
 * (RootRoute → ReviewPage), so this only catches actual unknown URLs.
 */
const NotFoundPage: React.FC = () => {
  const location = useLocation();

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <div style={{ fontSize: 48, marginBottom: 8 }}>🔍</div>
        <h1 style={{ margin: 0, color: "#323130", fontSize: 28 }}>Page not found</h1>
        <p style={{ color: "#605e5c", margin: "12px 0 4px", fontSize: 14, lineHeight: 1.6 }}>
          The URL
          {" "}
          <code style={codeStyle}>{location.pathname}{location.search}</code>
          {" "}
          doesn't match any page in this portal.
        </p>
        <p style={{ color: "#888", margin: "0 0 24px", fontSize: 13 }}>
          If you arrived here from a Slack link, the link may be malformed. Otherwise, head home.
        </p>
        <Link to="/" style={btnStyle}>← Go to home</Link>
      </div>
    </div>
  );
};

const pageStyle: React.CSSProperties = {
  padding: 48,
  fontFamily: "Segoe UI, sans-serif",
  display: "flex",
  justifyContent: "center",
};

const cardStyle: React.CSSProperties = {
  background: "white",
  border: "1px solid #e1dfdd",
  borderRadius: 6,
  padding: 40,
  textAlign: "center",
  maxWidth: 520,
};

const codeStyle: React.CSSProperties = {
  fontFamily: "monospace",
  fontSize: 12.5,
  background: "#f3f3f3",
  padding: "2px 8px",
  borderRadius: 3,
  wordBreak: "break-all",
};

const btnStyle: React.CSSProperties = {
  display: "inline-block",
  background: "#0078d4",
  color: "white",
  padding: "10px 22px",
  fontSize: 14,
  borderRadius: 4,
  textDecoration: "none",
};

export default NotFoundPage;
